<script setup>
import { computed } from "vue"

const apiBase = useApiBase()
const apiUrl = apiBase ? `${apiBase}/api/projects/` : "/api/projects/"
const { data } = await useFetch(apiUrl, { key: "home-projects" })

const projectsSection = computed(() => data.value?.section || null)
const projects = computed(() => (data.value?.items?.length ? data.value.items : []))
const featuredProjects = computed(() => projects.value.slice(0, 6))
</script>

<template>
  <section v-if="projectsSection" class="section-projects">
    <div class="section__title">
      <div class="title__text__wrapper">
        <div class="section__tag">
          <p class="text-regular-16 color-text-dark">{{ projectsSection.tag_label }}</p>
          <div class="icon-14">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 14 14" fill="none">
              <path
                d="M11.813 3.9375H2.18799C1.94636 3.9375 1.75049 4.13338 1.75049 4.375V11.375C1.75049 11.6166 1.94636 11.8125 2.18799 11.8125H11.813C12.0546 11.8125 12.2505 11.6166 12.2505 11.375V4.375C12.2505 4.13338 12.0546 3.9375 11.813 3.9375Z"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              />
              <path
                d="M9.1875 3.9375V3.0625C9.1875 2.83044 9.09531 2.60788 8.93122 2.44378C8.76712 2.27969 8.54456 2.1875 8.3125 2.1875H5.6875C5.45544 2.1875 5.23288 2.27969 5.06878 2.44378C4.90469 2.60788 4.8125 2.83044 4.8125 3.0625V3.9375"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              />
              <path
                d="M12.2503 6.90753C10.6547 7.83069 8.84331 8.3154 6.99989 8.3125C5.15678 8.3154 3.34568 7.83085 1.75024 6.90799"
                stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
              />
              <path d="M6.34375 6.5625H7.65625" stroke="currentColor" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <h3 class="h3-40 width-projects-title">
          {{ projectsSection.title_prefix }}
          <span class="color-span-scorpion">{{ projectsSection.title_suffix }}</span>
        </h3>
      </div>
      <div class="title__description__wrapper width-588">
        <div class="text-regular-16" v-html="projectsSection.description"></div>
      </div>
    </div>

    <div class="projects-grid">
      <ProjectCard v-for="project in featuredProjects" :key="project.slug" :project="project" />
    </div>

    <div class="projects-more">
      <NuxtLink to="/projects" class="button-classic projects-more__button">
        <p class="paragraph">Всі проекти</p>
      </NuxtLink>
    </div>

    <div class="projects-cta">
      <div class="projects-cta__text">
        <h4>{{ projectsSection.cta_title }}</h4>
        <div v-html="projectsSection.cta_text"></div>
      </div>
      <button type="button" class="button-classic projects-cta__button" data-openform>
        <p class="paragraph">{{ projectsSection.cta_button_label }}</p>
      </button>
    </div>

    <div id="projects" class="scroll-anchor"></div>
  </section>
</template>

<style lang="scss" scoped>
@use "/assets/scss/sections/_projects.scss";
</style>
